<div class="md-form md-outline mb-0 mt-3">
  <textarea [ngModel]="userId.lastname" (ngModelChange)="onLastname($event)" id="form-lastname" class="form-control textarea form-{{color}}" rows="1" type="text" mdbInput style="resize:none;"></textarea>
  <label for="form-lastname">{{ 'LASTNAME' | translate }}</label>
  <small id="form-lastname-help" class="form-text text-muted d-flex align-items-center">
    <i *ngIf="userId.isValid('lastname')" class="{{color}}-text fas fa-check-circle pr-1"></i>
    <i *ngIf="!userId.isValid('lastname')" class="text-warning fas fa-times-circle pr-1"></i>
    <span class="mr-auto">{{userId.lastname.length}}/{{userId.requirement('lastname').maxLength}} ({{ 'MINIMUM' | translate }}: {{userId.requirement('lastname').minLength}})</span>
  </small>
</div>